import React from 'react'
import PropTypes from 'prop-types'
import { USER } from 'helpers/constants'
import Slider from 'components/Slider'

const AgeRangeSlider = ({ min, max, icon, className, onChange }) => (
  <Slider
    className={className}
    icon={icon}
    minValue={USER.DESIRED_AGE_RANGE.min}
    maxValue={USER.DESIRED_AGE_RANGE.max}
    defaultValue={[USER.DESIRED_AGE_RANGE.min, USER.DESIRED_AGE_RANGE.max]}
    value={[min, max]}
    label={`${min} - ${max}`}
    onChange={values => onChange({ min: values[0], max: values[1] })}
  />
)

AgeRangeSlider.defaultProps = {
  min: USER.DESIRED_AGE_RANGE.min,
  max: USER.DESIRED_AGE_RANGE.max,
}

AgeRangeSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  icon: PropTypes.object,
  onChange: PropTypes.func,
}

export default AgeRangeSlider
